import {
  type ApolloClient,
  type NormalizedCacheObject,
  gql,
} from '@apollo/client';
import { type AdvancedUserInfoFilter } from './types';

export const useGetPanelMemberInfo = async (
  client: ApolloClient<NormalizedCacheObject>,
  filter: AdvancedUserInfoFilter,
): Promise<any> => {
  const { data } = await client.query({
    query: gql`
      query ($filter: AdvancedUserInfoFilter) {
        advancedUsersInfo(filter: $filter) {
          netId
          title
          displayName
          givenName
          surname
          department
          email
        }
      }
    `,
    variables: { filter },
    fetchPolicy: 'network-only',
  });

  return data.advancedUsersInfo;
};
